// src/Components/Dashboard/Login/index.tsx
import React, { useState } from 'react';
import axios, { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

export default function Login() {
    const [first_name, setFirstName] = useState('');
    const [last_name, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [error, setError] = useState<any | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await axios.post('https://stagingbackend.pulp.ph/api/register', {
                first_name,
                last_name,
                username,
                email,
                role,
                password,
                confirm_password,
            });

            if (response.status === 201) {
                // Handle successful login
                console.log('Registration successful:', response.data);
                const token = response.data.token;
                localStorage.setItem('authToken', token);
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                // Redirect to the dashboard
                navigate('/dashboard');
            } else {
                // Handle errors returned by the API
                setError(response.data.message || 'Registration failed');
            }
        } catch (err: unknown) {
            // Handle network errors
            if (axios.isAxiosError(err)) {
                const axiosError = err as AxiosError<any>; // Specify the response type as needed
                const errorMessage = axiosError.response?.data || 'An unexpected error occurred';
                setError(errorMessage); // Assuming setError expects a string or null
            } else {
                setError('An unexpected error occurred');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="relative flex flex-col justify-center items-center bg-pulp bg-cover bg-no-repeat bg-center h-screen w-screen">
            <div className="absolute bg-black opacity-80 h-screen w-screen"></div>
            <form onSubmit={handleLogin} className="relative w-[460px] bg-white p-[30px] rounded-md">
                <div className="mb-2">
                    <h2 className="GraphikSemibold text-center text-[36px] text-black font-semibold">Sign Up</h2>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <div className="col-span-1 mb-2">
                        <label htmlFor="first_name" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                            First Name
                        </label>
                        <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                            <input
                                type="text"
                                id="first_name"
                                value={first_name}
                                className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                                onChange={(e) => setFirstName(e.target.value)}
                                placeholder="Enter your First Name"
                                required/>
                        </div>
                    </div>

                    <div className="col-span-1 mb-2">
                        <label htmlFor="last_name" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                            Last Name
                        </label>
                        <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                            <input
                                type="text"
                                id="last_name"
                                value={last_name}
                                className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                                onChange={(e) => setLastName(e.target.value)}
                                placeholder="Enter your Last Name"
                                required/>
                        </div>
                    </div>
                </div>

                <div className="mb-2">
                    <label htmlFor="username" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                        Username
                    </label>
                    <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                        <input
                            type="text"
                            id="username"
                            value={username}
                            className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter your Username"
                            required/>
                    </div>
                </div>

                <div className="mb-2">
                    <label htmlFor="email" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                        Email
                    </label>
                    <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                        <input
                            type="email"
                            id="email"
                            value={email}
                            className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your Email"
                            required/>
                    </div>
                </div>

                <div className="mb-2">
                    <label htmlFor="role" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1 block">
                        Role
                    </label>
                    <select
                        id="role"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        className="w-full flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 px-2"
                        required>
                        <option value="">Select an Option</option>
                        <option value="Live">Pulp Live World</option>
                    </select>
                </div>

                <div className="mb-2">
                    <label htmlFor="password" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                        Password
                    </label>
                    <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                        <input
                            type="password"
                            id="password"
                            value={password}
                            className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your Password"
                            required/>
                    </div>
                </div>

                <div className="mb-2">
                    <label htmlFor="confirm_password" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                        Confirm Password
                    </label>
                    <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                        <input
                            type="password"
                            id="confirm_password"
                            value={confirm_password}
                            className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm your Password"
                            required/>
                    </div>
                </div>

                {error && (
                    <div className="bg-red-300 bg-opacity-40 border-[1px] border-red-300 p-2 rounded-md error m-0">
                        {Object.keys(error).map((key, index) => (
                            <label className="text-sm tracking-[1px] text-red-600 [text-shadow:0px_0px_1px_#17202A99] mb-2 text-left" key={index}>
                                <FontAwesomeIcon icon={faCircleExclamation} className="mr-2" />
                                {error[key]}
                            </label>
                        ))}
                    </div>
                )}

                <div className="flex justify-center mb-1">
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full text-sm tracking-[1px] text-white bg-red-600 hover:bg-red-800 active:transform active:translate-y-[1px] rounded-md p-2 mt-2">
                        {isLoading ? 'Creating Account...' : 'Register'}
                    </button>
                </div>

                <div className="flex justify-center">
                    <label className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] p-2">
                        Already have an account?
                        <a href='/' className="text-sm tracking-[1px] text-red-600 [text-shadow:0px_0px_1px_#17202A99] hover:text-red-800 ml-1">
                            Login
                        </a>
                    </label>
                </div>
            </form>
        </div>

        // <div className='bg-pulp bg-contain h-screen flex justify-center items-center font-graphik'>
        //     <div className="w-[300px] mt-0 mb-0 m-auto p-[2rem] border-solid-[1px] bg-white p-8 rounded-lg shadow-md">
        //         <h2 className='text-center text-4xl font-bold mb-4'>Sign Up</h2>
        //         <form onSubmit={handleLogin}>
        //             <div className='font-graphik'>
        //                 <label htmlFor="first_name" className='text-sm py-2'>First Name:</label>
        //                 <input
        //                     type="text"
        //                     id="first_name"
        //                     value={first_name}
        //                     className='p-2 bg-gray-200 rounded w-full'
        //                     onChange={(e) => setFirstName(e.target.value)}
        //                     required
        //                 />
        //                 <label htmlFor="last_name" className='text-sm py-2'>Last Name:</label>
        //                 <input
        //                     type="text"
        //                     id="last_name"
        //                     value={last_name}
        //                     className='p-2 bg-gray-200 rounded w-full'
        //                     onChange={(e) => setLastName(e.target.value)}
        //                     required
        //                 />
        //                 <label htmlFor="username" className='text-sm py-2'>Username:</label>
        //                 <input
        //                     type="text"
        //                     id="username"
        //                     value={username}
        //                     className='p-2 bg-gray-200 rounded w-full'
        //                     onChange={(e) => setUsername(e.target.value)}
        //                     required
        //                 />
        //                 <label htmlFor="email" className='text-sm py-2'>Email:</label>
        //                 <input
        //                     type="email"
        //                     id="email"
        //                     value={email}
        //                     className='p-2 bg-gray-200 rounded w-full'
        //                     onChange={(e) => setEmail(e.target.value)}
        //                     required
        //                 />
        //             </div>
        //             <label htmlFor="Role" className='text-sm py-2'>Role:</label>
        //             <select  
        //             id="role" 
        //             value={role}
        //             className='p-2 bg-gray-200 rounded w-full' 
        //             onChange={(e) => setRole(e.target.value)}>
        //                 <option value=""> Select Role</option>
        //                 <option value="IT">IT</option>
        //                 <option value="Magazine"> Pulp Magazine </option>
        //                 <option value="Live"> Pulp Live World </option>
        //                 <option value="Journal"> Freelance / Content Writer </option>
        //             </select>
        //             <div>
        //                 <label htmlFor="password" className='text-sm py-2'>Password:</label>
        //                 <input
        //                     type="password"
        //                     id="password"
        //                     value={password}
        //                     className='p-2 bg-gray-200 rounded w-full'
        //                     onChange={(e) => setPassword(e.target.value)}
        //                     required
        //                 />
        //                 <label htmlFor="confirm_password" className='text-sm py-2'>Confirm Password:</label>
        //                 <input
        //                     type="password"
        //                     id="confirm_password"
        //                     value={confirm_password}
        //                     className='p-2 bg-gray-200 rounded w-full'
        //                     onChange={(e) => setConfirmPassword(e.target.value)}
        //                     required
        //                 />
        //             </div>
        //             <div className="flex justify-center mt-4">
        //                 <button 
        //                 className='bg-red-500 font-semibold text-white p-2 rounded hover:bg-red-600 w-full'
        //                 type="submit" 
        //                 disabled={isLoading}>
        //                     {isLoading ? 'Creating Account...' : 'Register'}
        //                 </button>
        //             </div>
        //         </form>
        //         <p className='text-center p-2 text-sm'>Already have an account? <a href='/' className='font-semibold text-sm text-red-500 hover:text-red-600'>Login</a> </p>
        //         {error && (
        //             <div className="error">
        //                 {Object.keys(error).map((key, index) => (
        //                     <p key={index}>{error[key]}</p>
        //                 ))}
        //             </div>
        //         )}
        //     </div>
        // </div>
    );
};
